export class CXCaptureConfig {
  source_system_name = '';
  endpoint = '';

  constructor(options = {}) {
    Object.assign(this, options);
  }
}

export class GAConfig {
  mapping?: any;

  // use either gtag or ga based on the requested google analytics library... provide the id
  gtag?: string;
  ga?: string;
}

export enum validCXEvents {
  'plan-details_viewed' = 'plan-details_viewed',
  'plan_added-to-cart' = 'plan_added-to-cart',
  'plan_removed-from-cart' = 'plan_removed-from-cart',
  'contact-us_viewed' = 'contact-us_viewed',
  'plans_compared' = 'plans_compared',
  'application_printed' = 'application_printed',
}

export enum validGAEvents {
  'workflow_step' = 'workflow_step',
  'plan-details_viewed' = 'plan-details_viewed',
  'plan_added-to-cart' = 'plan_added-to-cart',
  'plan_removed-from-cart' = 'plan_removed-from-cart',
  'contact-us_viewed' = 'contact-us_viewed',
  'plans_compared' = 'plans_compared',
  'application_printed' = 'application_printed',
}

export class AnalyticsContext {
  CXKey?: validCXEvents;
  GAKey?: validGAEvents;
}

export const ProductPrefixes = {
  zshop: 'shp_',
  scout: 'ps_',
  'provider-portal': 'pp_',
  'member-portal': 'mp_',
  'broker-portal': 'bp_',
};

export class workflowContext {
  title!: string;
  key!: string;
  webuser_id?: number;
  web_session_id?: string;
}
